import { ChangeLogColumns } from "../enum/change-log-columns";
import { IChangeLogDto } from "../interface/dto/change-log.dto";
import { ChangeLogActionTypes, IChangeLogActions } from "./change-log.actions";

export interface IChangeLogTableState {
    changeLogs?: IChangeLogDto;
    isLoading: boolean;
    error?: string;
    pagination: {
        currentPage: number;
        itemsPerPage: number;
    };
    sorting: {
        column: ChangeLogColumns;
        order: "asc" | "desc";
    };
    searchQuery: string;
}

const initialState: IChangeLogTableState = {
    isLoading: false,
    pagination: {
        currentPage: 1,
        itemsPerPage: 10,
    },
    sorting: {
        column: ChangeLogColumns.DATE_CHANGED,
        order: "desc",
    },
    searchQuery: "",
};

export const changeLogReducer = (
    state = initialState,
    action: IChangeLogActions,
): IChangeLogTableState => {
    switch (action.type) {
        case ChangeLogActionTypes.CHANGE_LOG_INIT:
            return initialState;

        case ChangeLogActionTypes.CHANGE_LOG_LOAD_LISTS:
            return { ...state, isLoading: true };

        case ChangeLogActionTypes.CHANGE_LOG_LOAD_SUCCESS:
            return {
                ...state,
                isLoading: false,
                changeLogs: action.payload,
                error: undefined,
            };

        case ChangeLogActionTypes.CHANGE_LOG_LOAD_ERROR:
            return {
                ...state,
                isLoading: false,
                error: action.payload.error,
            };

        case ChangeLogActionTypes.CHANGE_LOG_SET_PAGINATION:
            return {
                ...state,
                pagination: {
                    ...state.pagination,
                    ...action.payload,
                    currentPage:
                        action.payload.itemsPerPage !==
                        state.pagination.itemsPerPage
                            ? 1
                            : action.payload.currentPage,
                },
            };

        case ChangeLogActionTypes.CHANGE_LOG_SET_SEARCHQUERY:
            return {
                ...state,
                searchQuery: action.payload,
                pagination: { ...state.pagination, currentPage: 1 },
            };

        case ChangeLogActionTypes.CHANGE_LOG_SET_SORTING:
            return { ...state, sorting: action.payload };

        default:
            return state;
    }
};
